import { DateInfo } from '@/types';
import { Solar } from 'lunar-typescript';

class LunarService {
  private readonly weekDays = [
    '星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'
  ];

  getDateInfo(date: Date = new Date()): DateInfo {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const weekDay = this.weekDays[date.getDay()];
    
    // 使用专业的lunar-typescript库进行农历计算
    const lunar = this.getLunarDate(date);
    
    return {
      monthDay: `${month}月${day}日`,
      weekDay,
      lunar,
      dateNumber: String(date.getDate())
    };
  }

  private getLunarDate(date: Date): string {
    try {
      // 使用lunar-typescript库进行准确的农历转换
      const solar = Solar.fromDate(date);
      const lunar = solar.getLunar();
      
      // 获取农历月份和日期的中文显示
      const monthStr = lunar.getMonthInChinese();
      const dayStr = lunar.getDayInChinese();
      
      return `农历${monthStr}${dayStr}`;
    } catch (error) {
      console.warn('农历计算失败，使用备用方案:', error);
      // 备用方案：简单显示
      return '农历计算中...';
    }
  }

  // 获取节气信息（使用专业库的节气计算）
  getSolarTerm(date: Date): string | null {
    try {
      const solar = Solar.fromDate(date);
      const lunar = solar.getLunar();
      
      // 获取节气信息
      const jieQi = lunar.getJieQi();
      return jieQi || null;
    } catch (error) {
      console.warn('节气计算失败:', error);
      return null;
    }
  }
}

export const lunarService = new LunarService();